// extracted by mini-css-extract-plugin
export default {"image":"wX-z","loaded":"xX-z"};